"use client";

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["id", "htmlFor", "passive"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import R, { createContext as D, useContext as h, useMemo as v, useState as k } from "react";
import { useEvent as P } from '../../hooks/use-event.js';
import { useId as _ } from '../../hooks/use-id.js';
import { useIsoMorphicEffect as S } from '../../hooks/use-iso-morphic-effect.js';
import { useSlot as A } from '../../hooks/use-slot.js';
import { useSyncRefs as B } from '../../hooks/use-sync-refs.js';
import { useDisabled as F } from '../../internal/disabled.js';
import { useProvidedId as M } from '../../internal/id.js';
import * as m from '../../utils/dom.js';
import { forwardRefWithAs as I, useRender as H } from '../../utils/render.js';
let L = D(null);
L.displayName = "LabelContext";
function C() {
  let n = h(L);
  if (n === null) {
    let l = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(l, C), l;
  }
  return n;
}
function N(n) {
  var a, e, o;
  let l = (e = (a = h(L)) == null ? void 0 : a.value) != null ? e : void 0;
  return ((o = n == null ? void 0 : n.length) != null ? o : 0) > 0 ? [l, ...n].filter(Boolean).join(" ") : l;
}
function V() {
  let {
    inherit: n = !1
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let l = N(),
    [a, e] = k([]),
    o = n ? [l, ...a].filter(Boolean) : a;
  return [o.length > 0 ? o.join(" ") : void 0, v(() => function (t) {
    let p = P(i => (e(u => [...u, i]), () => e(u => {
        let d = u.slice(),
          f = d.indexOf(i);
        return f !== -1 && d.splice(f, 1), d;
      }))),
      b = v(() => ({
        register: p,
        slot: t.slot,
        name: t.name,
        props: t.props,
        value: t.value
      }), [p, t.slot, t.name, t.props, t.value]);
    return R.createElement(L.Provider, {
      value: b
    }, t.children);
  }, [e])];
}
let G = "label";
function U(n, l) {
  var y;
  let a = _(),
    e = C(),
    o = M(),
    T = F(),
    {
      id: t = "headlessui-label-".concat(a),
      htmlFor: p = o != null ? o : (y = e.props) == null ? void 0 : y.htmlFor,
      passive: b = !1
    } = n,
    i = _objectWithoutProperties(n, _excluded),
    u = B(l);
  S(() => e.register(t), [t, e.register]);
  let d = P(s => {
      let g = s.currentTarget;
      if (!(s.target !== s.currentTarget && m.isInteractiveElement(s.target)) && (m.isHTMLLabelElement(g) && s.preventDefault(), e.props && "onClick" in e.props && typeof e.props.onClick == "function" && e.props.onClick(s), m.isHTMLLabelElement(g))) {
        let r = document.getElementById(g.htmlFor);
        if (r) {
          let E = r.getAttribute("disabled");
          if (E === "true" || E === "") return;
          let x = r.getAttribute("aria-disabled");
          if (x === "true" || x === "") return;
          (m.isHTMLInputElement(r) && (r.type === "file" || r.type === "radio" || r.type === "checkbox") || r.role === "radio" || r.role === "checkbox" || r.role === "switch") && r.click(), r.focus({
            preventScroll: !0
          });
        }
      }
    }),
    f = A(_objectSpread(_objectSpread({}, e.slot), {}, {
      disabled: T || !1
    })),
    c = _objectSpread(_objectSpread({
      ref: u
    }, e.props), {}, {
      id: t,
      htmlFor: p,
      onClick: d
    });
  return b && ("onClick" in c && (delete c.htmlFor, delete c.onClick), "onClick" in i && delete i.onClick), H()({
    ourProps: c,
    theirProps: i,
    slot: f,
    defaultTag: p ? G : "div",
    name: e.name || "Label"
  });
}
let j = I(U),
  Z = Object.assign(j, {});
export { Z as Label, C as useLabelContext, N as useLabelledBy, V as useLabels };